// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"c4f617d85b8b03950521","293":"2ad5364e8b8415c499ea","522":"4e98084ca66a1fee15dc"}[chunkId] + ".js";
};